/**
 * Fail-closed env validation for sentinel-driver.
 * Throws before React mounts if required vars are absent.
 * C-11 Production Readiness — config safety.
 *
 * Delegates resolution to {@link @rtvloco/platform/env} so this file does not
 * read `window.__ENV__` or `import.meta.env.VITE_*` directly (canonical pattern).
 */

import {
  isMockMode,
  validateConfig,
  showBootstrapError,
  type ConfigRequirement,
  type ConfigValidationError,
} from '@rtvloco/platform/env';

const REQUIRED: ReadonlyArray<ConfigRequirement> = [{ key: 'VITE_GRAPHQL_URL', description: 'GraphQL HTTP endpoint (https://...)' },
  { key: 'VITE_GRAPHQL_WS_URL', description: 'GraphQL WebSocket endpoint (wss://...)' },];

export function validateEnv(): void {
  if (isMockMode) return;

  const errors: ConfigValidationError[] = validateConfig([...REQUIRED]);

  if (errors.length > 0) {
    showBootstrapError(errors, 'sentinel-driver');
    throw new Error(
      `[sentinel-driver] Environment configuration error: ${errors.map(e => e.canonicalKey).join(', ')}`,
    );
  }
}
